import React from 'react';
import { FormContent } from './form-content';

export const defaultConfig = {
  view: () => null,
  repository: () => ({}),
  render: () => <FormContent />,
  machineOptions: {},
};
